/* istanbul ignore file */

export { ArticleSection as default } from "./ArticleSection";
